import React from 'react';
import cvPdf from '../BERTAINA-LOICHEMOL-Raphael.pdf';

export default function CV() {
  return (
    <section id="cv" className="cv-strip-wrap">
      <div className="container-x">
        <a href={cvPdf} download="BERTAINA-LOICHEMOL-Raphael.pdf" target="_blank" rel="noopener noreferrer" className="cv-strip">
          <div className="l" data-reveal="">
            <span className="t">Curriculum Vitæ <em>— the whole story, on one page.</em></span>
            <span className="s">PDF · ~90 KB · updated 2026</span>
          </div>
          <span className="cv-btn" data-reveal="" data-reveal-delay="1">
            <span className="label">Download CV</span>
            <svg className="arrow" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6"
                 style={{ width: 16, height: 16 }}>
              <path d="M8 2v10M3.5 7.5L8 12l4.5-4.5M2 14h12" />
            </svg>
          </span>
        </a>
      </div>
    </section>
  );
}
